var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"default-active":_vm.activeMenu}},_vm._l((_vm.menu_routes),function(route,index){return _c('sidebar-item',{key:index,attrs:{"item":route,"base-path":route.path}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }